import $api from "@/zapi-frontend/shared/api/axios";
import { GetIntelligenceQuestionsSchema, TIntelligenceQuestions } from "../model/types";

export async function getIntelligenceQuestions(
  { projectId, chapterId }: { projectId: string; chapterId: string }
) {
  const response = await $api.get(`/intelligence/questions?projectId=${projectId}&projectChapterId=${chapterId}`);
  const data = GetIntelligenceQuestionsSchema.parse(response.data as TIntelligenceQuestions);
  return data.questions;
}
